module.exports = __webpack_public_path__ + "img/img_caishen.9bae5aca.png";